<script>
import Dropdown from '@/components/atoms/Dropdown'
import { mapGetters } from 'vuex'
export default {
    name: 'Diets',
    components: { Dropdown },
    props: {
        model: null,
    },
    computed: {
        ...mapGetters(['lgDevice']),
    },
    methods: {
        open(e) {
            e.stopPropagation()
            e.preventDefault()
            this.$refs.dropdown.open()
        },
    },
}
</script>

<template lang="pug">
.diets(v-if="model && model.length")
    span.diet(v-for="(diet, index) in model" :key="`diet-show-${index}`" v-tooltip.hover.top="$t(`diet.${diet}`)" :class="{'ml-1': index}") {{$t(`diet.${diet}_short`)}}
</template>
